export default "__VITE_ASSET__10a8655c__"